export default __webpack_public_path__ + "static/media/Instagram.a07f0832.svg";